<h2 mat-dialog-title>{{ 'join_game_dialog.title' | translate | async }}</h2>
<mat-dialog-content>
  <p>{{ 'join_game_dialog.description' | translate | async }}</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'join_game_dialog.access_code' | translate | async }}</mat-label>
    <input matInput [(ngModel)]="accessCode" [placeholder]="('join_game_dialog.access_code_placeholder' | translate | async) || ''">
  </mat-form-field>

  <mat-slide-toggle [(ngModel)]="isViewer" class="join-mode-toggle">
    {{ 'join_game_dialog.join_as_viewer' | translate | async }}
  </mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'general.buttons.cancel' | translate | async }}</button>
  <button mat-raised-button color="primary" (click)="onJoin()" (keyup.enter)="onJoin()" [disabled]="!accessCode || loading">
    {{ isViewer ? ('join_game_dialog.view' | translate | async) : ('join_game_dialog.join' | translate | async) }}
  </button>
</mat-dialog-actions>
